import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { init, Form } from '@feathery/react';
import { LangCode, LangCode2 } from "../utils/lang"
import { useLocation } from '@reach/router';

const EmbedForm = ({ blok }) => {
  const langCode = LangCode()
  const langCode2 = LangCode2()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const affiliate = queryParams.get('affiliate');
  var initialValues = {}
  initialValues['affiliate'] = affiliate ? affiliate : '';
  initialValues['language'] = langCode2
  
  // console.log(langCode)
  // console.log(initialValues);
  // console.log(blok)
  // Initialize Feathery
  init('eeaa5623-09b6-42e5-944d-b11974b0154b');  
  return (
    <section className="mx-auto" {...storyblokEditable(blok)}>
      <Form
        language={langCode}
        initialValues={initialValues}
        className="bg-white"
        formName={blok.formName}
      />
    </section>
  )
};

export default EmbedForm;
